import React from 'react';
import 'contents/assets/scss/page/data.scss';
import Paging from '../../component/Inc/Paging';
import Upload from '../../component/Inc/Upload';
import BtnLike from "../../component/Inc/BtnLike";//좋아요 버튼

function Notice() {
  return (
    <main className="com_container">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu4_2">자료실 공지사항</h2>
          <button className="com_btn orange s btn_plus">내용 등록</button>
        </section>
        <section className="com_pg_container">
          <section className="box">
            <div className="com_board_list__top">
              <section className="com_board_search end">
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="8%" />
                <col width="10%" />
                <col width="9%" />
                <col />
                <col width="9%" />
                <col width="9%" />
                <col width="9%" />
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>등록일</th>
                  <th>카테고리</th>
                  <th>내용</th>
                  <th>파일</th>
                  <th>등록자</th>
                  <th>조회수</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <BtnLike/>
                  </td>
                  <td className="td_date">2022.08.25</td>
                  <td>인문</td>
                  <td>자연계 공지가 떴습니다.자연계 공지가 떴습니다.자연계 공지가 떴습니다.자연계 공지가 떴습니다.자연계 공지가 떴습니다.자연계 공지가 떴습니다.자연계 공지가 떴습니다.</td>
                  <td>
                    <button className="btn_link blue">다운로드</button>
                  </td>
                  <td>김길동111</td>
                  <td>18</td>
                </tr>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i, idx) => {
                  return (
                    <tr key={idx}>
                      <td>{10 - idx}</td>
                      <td className="td_date">2022.08.25</td>
                      <td>자연</td>
                      <td>자연계 공지가 떴습니다.</td>
                      <td>
                        <button className="btn_link blue">다운로드</button>
                      </td>
                      <td>김길동111</td>
                      <td>18</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <Paging />
          </section>
          <section className="box">
            <div className="detail_tit dot">상세보기</div>
            <div className="com_info">
              <p className="name">홍길동104</p>
              <span className="dot" />
              <p className="date">2023.05.20 11:30</p>
              <div className="count">
                <p>
                  댓글 <span className="cnt">10</span>
                </p>
                <span className="dot" />
                <p>
                  조회 <span className="cnt">321</span>
                </p>
              </div>
            </div>
            <div className="com_input_wrap">
              <div className="sec_input select_box">
                <select className="select">
                  <option value="">과목 선택</option>
                </select>
                <div className="com_btn_wrap">
                  <BtnLike/>
                  <button className="btn_edit"></button>
                  <button className="btn_delete"></button>
                </div>
              </div>
              <div className="sec_input">
                <input type="text" className="input" placeholder="제목 입력" />
              </div>
              <div className="editor">내용입력(에디터)</div>
              <div className="com_input_upload">
                <Upload title="파일 등록" className="com_btn gray s wl" />
                <p className="file">
                  <span className="txt">File name.pdf</span>
                  <button type="button" className="btn_del_file" onClick={() => {}}></button>
                  <button type="button" className="btn_down" onClick={() => {}}></button>
                </p>
              </div>
            </div>
            <div className="com_btn_wrap center bottom">
              <div className="com_btn orange xs wl">등록</div>
            </div>

            <div className="com_comment_wrap type_board">
              <ul className="comment_list">
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i, idx) => {
                  return (
                    <li className="item" key={idx}>
                      <div className="info">
                        <p className="name">홍길동104</p>
                        <span className="dot" />
                        <p className="date">2023.05.20 11:30</p>
                        <div className="com_btn_wrap">
                          <button className="btn_edit"></button>
                          <button className="btn_delete"></button>
                        </div>
                      </div>
                      <p className="txt">
                        축하드려요~!축하드려요~!축하드려요~!축하드려요~!축하드려요~!축하드려요~!축하드려요~!
                        <br />
                        축하드려요~!
                      </p>
                    </li>
                  );
                })}
              </ul>
              <div className="comment_input">
                <textarea type="text" className="textarea" placeholder="댓글을 입력해주세요" />
                <button className="com_btn gray l">등록</button>
              </div>
            </div>
          </section>
        </section>
      </div>
    </main>
  );
}

export default Notice;
